/**
 * @generated SignedSource<<39469d6744e6343500f0b93979bfb8f5>>
 * @relayHash 19f1f2ebca75272aa6fb09ac47ff7434
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d4156ee4486d3b11b9dfff987132c48aca5a82e89639d1c03a248f4c84e5e6d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3d4156ee4486d3b11b9dfff987132c48aca5a82e89639d1c03a248f4c84e5e6d",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
